// FullPageLoader.jsx
import React from "react";
import KidoLoader from "../common/KidoLoader";

const FullPageLoader = () => {
  return <KidoLoader overlay label="Working on it" />;
};

export default FullPageLoader;
